import { GetterTree } from 'vuex'
import { MediaState } from '@/modules/media/store'
import { RootState } from '@/store/types'
import { MediaUpload, MediaObject } from '@/modules/media/types'

const buildEmptyUpload = (): MediaUpload => {
    return new MediaUpload(null, new MediaObject())
}

const getters: GetterTree<MediaState, RootState> = {

    /**
     * Obtiene un objeto de subida en base a su id
     */
    'mediaUpload': (state) => (id: string): MediaUpload | null => {
        const result = state.uploadQueue.find(mp => mp.id === id)
        if (result instanceof MediaUpload) {
            return result
        }

        return null
    },

    'upload/current': (state) => {
        return state.uploadQueue.find(mu => mu.id === state.currentUpload) || buildEmptyUpload()
    },
    /**
     * Obtiene un objeto de subida en base al id de su objeto multimedia
     */
    'getMediaUploadByMediaId': (state) => (media: MediaObject): MediaUpload | null => {
        const result = state.uploadQueue.find(mp => mp.media.id === media.id)
        if (!result) {
            return null
        }

        return result
    },

    'currentUpload': (state, getters) => {
        return getters.mediaUpload(state.currentUpload) || new MediaUpload()
    },

    /**
     * Permite obtener un objeto multimedia en base a un identificador
     */
    'object': (state) => (id: number): MediaObject | undefined => {
        return state.objects.find(mo => mo.id === id)
    },
    /**
     * Comprueba si el id
     *
     * @param state
     */
    'itemIsSelected': (state) => (id: number) => state.selectedObjects.findIndex(s => s === id) !== -1,
}

export default getters
